/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigDecimal: { input: number; output: number; }
  Date: { input: Date | string; output: Date; }
  DateTime: { input: Date; output: Date; }
  Long: { input: number; output: number; }
  UUID: { input: string; output: string; }
};

export type BodyType = {
  __typename?: 'BodyType';
  bodyTypeName: Scalars['String']['output'];
  bodyTypeNumber: Scalars['Int']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  shortCode?: Maybe<Scalars['String']['output']>;
};

export type Brand = {
  __typename?: 'Brand';
  brandName: Scalars['String']['output'];
  brandNumber: Scalars['String']['output'];
  brandShortName?: Maybe<Scalars['String']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
};

export type CollectionColour = {
  __typename?: 'CollectionColour';
  changedBy?: Maybe<Scalars['UUID']['output']>;
  changedDate?: Maybe<Scalars['String']['output']>;
  collectionColourNumber?: Maybe<Scalars['UUID']['output']>;
  collectionNumber: Scalars['Int']['output'];
  createdBy?: Maybe<Scalars['UUID']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  masterColour: MasterColour;
};

export type CollectionColourConnection = {
  __typename?: 'CollectionColourConnection';
  edges?: Maybe<Array<CollectionColourEdge>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount: Scalars['Int']['output'];
};

export type CollectionColourEdge = {
  __typename?: 'CollectionColourEdge';
  cursor: Scalars['String']['output'];
  node: CollectionColour;
};

export type CollectionColourSaveInput = {
  changedBy?: InputMaybe<Scalars['UUID']['input']>;
  collectionNumber: Scalars['Long']['input'];
  createdBy: Scalars['UUID']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  masterColourNumber: Scalars['Long']['input'];
};

export type ColourGroup = {
  __typename?: 'ColourGroup';
  colourGroupName: Scalars['String']['output'];
  colourGroupNumber: Scalars['Int']['output'];
  isDeleted: Scalars['Boolean']['output'];
  masterColours: Array<Maybe<MasterColour>>;
};

export type Country = {
  __typename?: 'Country';
  countryIsoCode3: Scalars['String']['output'];
  countryName: Scalars['String']['output'];
  countryNumber: Scalars['Int']['output'];
};

export type CountryConnection = {
  __typename?: 'CountryConnection';
  edges?: Maybe<Array<CountryEdge>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount: Scalars['Int']['output'];
};

export type CountryEdge = {
  __typename?: 'CountryEdge';
  cursor: Scalars['String']['output'];
  node: Country;
};

export type DeliveryPeriod = {
  __typename?: 'DeliveryPeriod';
  deliveryPeriodName: Scalars['String']['output'];
  deliveryPeriodNumber: Scalars['Int']['output'];
  endDate: Scalars['Date']['output'];
  startDate: Scalars['Date']['output'];
};

export type Factory = {
  __typename?: 'Factory';
  countryCode?: Maybe<Scalars['String']['output']>;
  factoryName: Scalars['String']['output'];
  factoryNumber: Scalars['String']['output'];
};

export type FactorySupplier = {
  __typename?: 'FactorySupplier';
  factoryName: Scalars['String']['output'];
  factoryNumber: Scalars['String']['output'];
  suppliers: Array<FactorySupplierInfo>;
};

export type FactorySupplierInfo = {
  __typename?: 'FactorySupplierInfo';
  supplierName: Scalars['String']['output'];
  supplierNumber: Scalars['String']['output'];
};

export enum FactoryTypeEnum {
  Marketing = 'MARKETING',
  Purchase = 'PURCHASE',
  Sample = 'SAMPLE'
}

export type Fit = {
  __typename?: 'Fit';
  fitName: Scalars['String']['output'];
  fitNumber: Scalars['Int']['output'];
  fitTypes: Array<Maybe<FitType>>;
  isDeleted: Scalars['Boolean']['output'];
  masterFitNumber?: Maybe<Scalars['Int']['output']>;
};

export type FitType = {
  __typename?: 'FitType';
  fitTypeName: Scalars['String']['output'];
  fitTypeNumber: Scalars['Int']['output'];
};

export type Gender = {
  __typename?: 'Gender';
  genderName: Scalars['String']['output'];
  genderNumber: Scalars['Int']['output'];
};

export type KeyOrder = {
  __typename?: 'KeyOrder';
  expectedArrivalDate?: Maybe<Scalars['Date']['output']>;
  keyOrderName: Scalars['String']['output'];
  keyOrderNumber: Scalars['Int']['output'];
  storeDeliveryDate?: Maybe<Scalars['Date']['output']>;
};

export type Label = {
  __typename?: 'Label';
  labelName: Scalars['String']['output'];
  labelNumber: Scalars['Int']['output'];
};

export type MasterColour = {
  __typename?: 'MasterColour';
  colourGroupNumbers: Array<Scalars['Long']['output']>;
  colourTypeName?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['UUID']['output']>;
  createdByDisplayName?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['String']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  mainColourName?: Maybe<Scalars['String']['output']>;
  masterColourCode?: Maybe<Scalars['String']['output']>;
  masterColourHexCode: Scalars['String']['output'];
  masterColourName: Scalars['String']['output'];
  masterColourNumber: Scalars['Long']['output'];
  standardColourName?: Maybe<Scalars['String']['output']>;
};

export type MasterColourConnection = {
  __typename?: 'MasterColourConnection';
  edges?: Maybe<Array<MasterColourEdge>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount: Scalars['Int']['output'];
};

export type MasterColourEdge = {
  __typename?: 'MasterColourEdge';
  cursor: Scalars['String']['output'];
  node: MasterColour;
};

export type MasterStyleCategory = {
  __typename?: 'MasterStyleCategory';
  masterStyleCategoryName: Scalars['String']['output'];
  masterStyleCategoryNumber: Scalars['String']['output'];
  masterStyleSubcategory: Array<Maybe<MasterStyleSubcategory>>;
};

export type MasterStyleSubcategory = {
  __typename?: 'MasterStyleSubcategory';
  masterStyleSubcategoryAttributes: Array<Maybe<MasterStyleSubcategoryAttribute>>;
  masterStyleSubcategoryName?: Maybe<Scalars['String']['output']>;
  masterStyleSubcategoryNumber: Scalars['String']['output'];
};

export type MasterStyleSubcategoryAttribute = {
  __typename?: 'MasterStyleSubcategoryAttribute';
  masterStyleSubcategoryProperty: Scalars['String']['output'];
  propertyTypeNumber?: Maybe<Scalars['Int']['output']>;
};

export type MenuItem = {
  __typename?: 'MenuItem';
  Children?: Maybe<Array<Maybe<MenuItem>>>;
  isBottomItem: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type MenuResponse = {
  __typename?: 'MenuResponse';
  items: Array<Maybe<MenuItem>>;
  routes: Array<Maybe<RouteMap>>;
};

export type MenuRoute = {
  __typename?: 'MenuRoute';
  href?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  path?: Maybe<Scalars['String']['output']>;
  targetAppKey?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  saveCollectionColour?: Maybe<Response>;
};


export type MutationSaveCollectionColourArgs = {
  collectionColourSaveInput?: InputMaybe<Array<CollectionColourSaveInput>>;
};

export type Neck = {
  __typename?: 'Neck';
  isDeleted: Scalars['Boolean']['output'];
  neckName: Scalars['String']['output'];
  neckNumber: Scalars['Int']['output'];
  neckTypes: Array<Maybe<NeckType>>;
};

export type NeckType = {
  __typename?: 'NeckType';
  neckTypeName: Scalars['String']['output'];
  neckTypeNumber: Scalars['Int']['output'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PaginationInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};

export type ProductLine = {
  __typename?: 'ProductLine';
  brandNumber: Scalars['String']['output'];
  gender: Array<Maybe<Gender>>;
  isDeleted: Scalars['Boolean']['output'];
  productLineName: Scalars['String']['output'];
  productLineNumber: Scalars['String']['output'];
};

export type PurchaseDivision = {
  __typename?: 'PurchaseDivision';
  brandNumber: Scalars['String']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  purchaseDivisionName: Scalars['String']['output'];
  purchaseDivisionNumber: Scalars['Int']['output'];
};

export type Quality = {
  __typename?: 'Quality';
  isDeleted: Scalars['Boolean']['output'];
  qualityName: Scalars['String']['output'];
  qualityNumber: Scalars['Int']['output'];
};

export type Query = {
  __typename?: 'Query';
  bodyTypes: Array<Maybe<BodyType>>;
  brands?: Maybe<Array<Maybe<Brand>>>;
  collectionColours?: Maybe<CollectionColourConnection>;
  colourGroups: Array<Maybe<ColourGroup>>;
  countries?: Maybe<CountryConnection>;
  deliveryPeriods?: Maybe<Array<DeliveryPeriod>>;
  factories: Array<Maybe<FactorySupplier>>;
  fits: Array<Maybe<Fit>>;
  keyOrders: Array<Maybe<KeyOrder>>;
  labels?: Maybe<Array<Label>>;
  masterColours?: Maybe<MasterColourConnection>;
  masterStyleCategories: Array<Maybe<MasterStyleCategory>>;
  menu: MenuResponse;
  necks: Array<Maybe<Neck>>;
  productLines: Array<Maybe<ProductLine>>;
  purchaseDivisions: Array<Maybe<PurchaseDivision>>;
  qualities?: Maybe<Array<Maybe<Quality>>>;
  sleeves: Array<Maybe<Sleeve>>;
  strategicTypes?: Maybe<Array<Maybe<StrategicType>>>;
  suppliers: Array<Maybe<Supplier>>;
  validateStyleSupplier: Array<StyleSupplierResponse>;
};


export type QueryBodyTypesArgs = {
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBrandsArgs = {
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCollectionColoursArgs = {
  collectionNumber: Scalars['Int']['input'];
  generalQuery?: InputMaybe<Scalars['String']['input']>;
  pagination: PaginationInput;
};


export type QueryColourGroupsArgs = {
  colourGroupNumbers: Array<InputMaybe<Scalars['Int']['input']>>;
  generalQuery?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCountriesArgs = {
  generalQuery?: InputMaybe<Scalars['String']['input']>;
  pagination: PaginationInput;
};


export type QueryFactoriesArgs = {
  brandNumber: Scalars['String']['input'];
  factoryTypeToInclude?: InputMaybe<FactoryTypeEnum>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  supplierNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryFitsArgs = {
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryKeyOrdersArgs = {
  brandNumber: Array<InputMaybe<Scalars['String']['input']>>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLabelsArgs = {
  brandNumber: Scalars['String']['input'];
  labelTypeNumber: Scalars['Int']['input'];
};


export type QueryMasterColoursArgs = {
  generalQuery?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  pagination: PaginationInput;
  sortBy?: InputMaybe<SortByInput>;
};


export type QueryMasterStyleCategoriesArgs = {
  masterStyleCategoryNumber?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNecksArgs = {
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryProductLinesArgs = {
  brandNumber: Scalars['String']['input'];
  generalQuery?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPurchaseDivisionsArgs = {
  brandNumber: Scalars['String']['input'];
  generalQuery?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryQualitiesArgs = {
  generalQuery?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySleevesArgs = {
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryStrategicTypesArgs = {
  brandNumber: Scalars['String']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySuppliersArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  brandNumber?: InputMaybe<Scalars['String']['input']>;
  factoryTypeToInclude?: InputMaybe<FactoryTypeEnum>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  supplierNumber?: InputMaybe<Scalars['String']['input']>;
};


export type QueryValidateStyleSupplierArgs = {
  brandNumber: Scalars['String']['input'];
  styleSuppliers: Array<StyleSupplierInput>;
};

export type Response = {
  __typename?: 'Response';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type RouteMap = {
  __typename?: 'RouteMap';
  key: Scalars['String']['output'];
  value: MenuRoute;
};

export type Sleeve = {
  __typename?: 'Sleeve';
  isDeleted: Scalars['Boolean']['output'];
  sleeveName: Scalars['String']['output'];
  sleeveNumber: Scalars['Int']['output'];
};

export type SortByInput = {
  sortByAttribute?: InputMaybe<Scalars['String']['input']>;
  sortByDirection?: InputMaybe<Scalars['String']['input']>;
};

export type StrategicType = {
  __typename?: 'StrategicType';
  brandNumber: Scalars['String']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  strategicType?: Maybe<Scalars['String']['output']>;
  strategicTypeNumber: Scalars['Int']['output'];
};

export type StyleSupplierInput = {
  factoryPublicId?: InputMaybe<Scalars['Long']['input']>;
  supplierPublicId: Scalars['Long']['input'];
};

export type StyleSupplierResponse = {
  __typename?: 'StyleSupplierResponse';
  factory?: Maybe<ValidationResponse>;
  isValid?: Maybe<Scalars['Boolean']['output']>;
  supplier: ValidationResponse;
};

export type Supplier = {
  __typename?: 'Supplier';
  factories?: Maybe<Array<Maybe<Factory>>>;
  paymentTermsCode?: Maybe<Scalars['String']['output']>;
  supplierName: Scalars['String']['output'];
  supplierNumber: Scalars['String']['output'];
};

export type ValidationResponse = {
  __typename?: 'ValidationResponse';
  isValid: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  publicId: Scalars['Long']['output'];
};

export type MasterColourFragmentFragment = { __typename?: 'MasterColour', colourGroupNumbers: Array<number>, masterColourNumber: number, masterColourName: string, masterColourHexCode: string, masterColourCode?: string | null, colourTypeName?: string | null, isDeleted: boolean };

export type PageInfoFragmentFragment = { __typename?: 'PageInfo', hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, startCursor?: string | null, endCursor?: string | null };

export type SaveCollectionColoursMutationVariables = Exact<{
  collectionColourSaveInput?: InputMaybe<Array<CollectionColourSaveInput> | CollectionColourSaveInput>;
}>;


export type SaveCollectionColoursMutation = { __typename?: 'Mutation', saveCollectionColour?: { __typename?: 'Response', message?: string | null, status?: string | null } | null };

export type GetAllBrandsQueryVariables = Exact<{
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllBrandsQuery = { __typename?: 'Query', brands?: Array<{ __typename?: 'Brand', brandNumber: string, brandName: string, brandShortName?: string | null, isDeleted?: boolean | null } | null> | null };

export type GetAllColourGroupsQueryVariables = Exact<{
  colourGroupNumbers: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
  generalQuery?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAllColourGroupsQuery = { __typename?: 'Query', colourGroups: Array<{ __typename?: 'ColourGroup', colourGroupName: string, colourGroupNumber: number, isDeleted: boolean, masterColours: Array<{ __typename?: 'MasterColour', colourGroupNumbers: Array<number>, masterColourNumber: number, masterColourName: string, masterColourHexCode: string, masterColourCode?: string | null, colourTypeName?: string | null, isDeleted: boolean } | null> } | null> };

export type GetAllCountriesQueryVariables = Exact<{
  generalQuery?: InputMaybe<Scalars['String']['input']>;
  pagination: PaginationInput;
}>;


export type GetAllCountriesQuery = { __typename?: 'Query', countries?: { __typename?: 'CountryConnection', totalCount: number, pageInfo?: { __typename?: 'PageInfo', hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, startCursor?: string | null, endCursor?: string | null } | null, edges?: Array<{ __typename?: 'CountryEdge', cursor: string, node: { __typename?: 'Country', countryNumber: number, countryName: string, countryIsoCode3: string } }> | null } | null };

export type GetAllKeyOrdersQueryVariables = Exact<{
  brandNumber: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllKeyOrdersQuery = { __typename?: 'Query', keyOrders: Array<{ __typename?: 'KeyOrder', keyOrderNumber: number, keyOrderName: string, expectedArrivalDate?: Date | null, storeDeliveryDate?: Date | null } | null> };

export type GetAllLabelsQueryVariables = Exact<{
  brandNumber: Scalars['String']['input'];
  labelTypeNumber: Scalars['Int']['input'];
}>;


export type GetAllLabelsQuery = { __typename?: 'Query', labels?: Array<{ __typename?: 'Label', labelNumber: number, labelName: string }> | null };

export type GetAllMasterStyleCategoriesQueryVariables = Exact<{
  categoryNumber?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAllMasterStyleCategoriesQuery = { __typename?: 'Query', masterStyleCategories: Array<{ __typename?: 'MasterStyleCategory', masterStyleCategoryNumber: string, masterStyleCategoryName: string, masterStyleSubcategory: Array<{ __typename?: 'MasterStyleSubcategory', masterStyleSubcategoryNumber: string, masterStyleSubcategoryName?: string | null, masterStyleSubcategoryAttributes: Array<{ __typename?: 'MasterStyleSubcategoryAttribute', propertyTypeNumber?: number | null, masterStyleSubcategoryProperty: string } | null> } | null> } | null> };

export type GetAllSuppliersQueryVariables = Exact<{
  brandNumber: Scalars['String']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  factoryTypeToInclude?: InputMaybe<FactoryTypeEnum>;
}>;


export type GetAllSuppliersQuery = { __typename?: 'Query', suppliers: Array<{ __typename?: 'Supplier', supplierNumber: string, supplierName: string, paymentTermsCode?: string | null, factories?: Array<{ __typename?: 'Factory', factoryNumber: string, factoryName: string, countryCode?: string | null } | null> | null } | null> };

export type GetCollectionColoursQueryVariables = Exact<{
  generalQuery: Scalars['String']['input'];
  collectionNumber: Scalars['Int']['input'];
  pagination: PaginationInput;
}>;


export type GetCollectionColoursQuery = { __typename?: 'Query', collectionColours?: { __typename?: 'CollectionColourConnection', totalCount: number, pageInfo?: { __typename?: 'PageInfo', hasPreviousPage?: boolean | null, hasNextPage?: boolean | null, startCursor?: string | null, endCursor?: string | null } | null, edges?: Array<{ __typename?: 'CollectionColourEdge', node: { __typename?: 'CollectionColour', collectionColourNumber?: string | null, collectionNumber: number, createdBy?: string | null, changedBy?: string | null, changedDate?: string | null, isDeleted?: boolean | null, masterColour: { __typename?: 'MasterColour', masterColourNumber: number, masterColourName: string, masterColourHexCode: string, masterColourCode?: string | null, colourTypeName?: string | null, isDeleted: boolean } } }> | null } | null };

export type GetAllDeliveryPeriodsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllDeliveryPeriodsQuery = { __typename?: 'Query', deliveryPeriods?: Array<{ __typename?: 'DeliveryPeriod', deliveryPeriodNumber: number, deliveryPeriodName: string, startDate: Date, endDate: Date }> | null };

export type GetFactoriesQueryVariables = Exact<{
  brandNumber: Scalars['String']['input'];
  supplierNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  factoryTypeToInclude?: InputMaybe<FactoryTypeEnum>;
}>;


export type GetFactoriesQuery = { __typename?: 'Query', factories: Array<{ __typename?: 'FactorySupplier', factoryNumber: string, factoryName: string, suppliers: Array<{ __typename?: 'FactorySupplierInfo', supplierName: string, supplierNumber: string }> } | null> };

export type GetMasterColoursQueryVariables = Exact<{
  generalQuery: Scalars['String']['input'];
  pagination: PaginationInput;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetMasterColoursQuery = { __typename?: 'Query', masterColours?: { __typename?: 'MasterColourConnection', totalCount: number, pageInfo?: { __typename?: 'PageInfo', hasPreviousPage?: boolean | null, hasNextPage?: boolean | null, startCursor?: string | null, endCursor?: string | null } | null, edges?: Array<{ __typename?: 'MasterColourEdge', node: { __typename?: 'MasterColour', colourGroupNumbers: Array<number>, masterColourNumber: number, masterColourName: string, masterColourHexCode: string, masterColourCode?: string | null, colourTypeName?: string | null, isDeleted: boolean } }> | null } | null };

export type GetProductLineOptionsQueryVariables = Exact<{
  brandNumber: Scalars['String']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetProductLineOptionsQuery = { __typename?: 'Query', productLines: Array<{ __typename?: 'ProductLine', productLineNumber: string, productLineName: string } | null> };

export type GetPurchaseDivisionOptionsQueryVariables = Exact<{
  brandNumber: Scalars['String']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPurchaseDivisionOptionsQuery = { __typename?: 'Query', purchaseDivisions: Array<{ __typename?: 'PurchaseDivision', purchaseDivisionName: string, purchaseDivisionNumber: number } | null> };

export type GetStrategicTypesQueryVariables = Exact<{
  brandNumber: Scalars['String']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetStrategicTypesQuery = { __typename?: 'Query', strategicTypes?: Array<{ __typename?: 'StrategicType', strategicTypeNumber: number, strategicType?: string | null, displayName?: string | null, brandNumber: string, isDeleted?: boolean | null } | null> | null };

export const MasterColourFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MasterColourFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MasterColour"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"colourGroupNumbers"}},{"kind":"Field","name":{"kind":"Name","value":"masterColourNumber"}},{"kind":"Field","name":{"kind":"Name","value":"masterColourName"}},{"kind":"Field","name":{"kind":"Name","value":"masterColourHexCode"}},{"kind":"Field","name":{"kind":"Name","value":"masterColourCode"}},{"kind":"Field","name":{"kind":"Name","value":"colourTypeName"}},{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}}]}}]} as unknown as DocumentNode<MasterColourFragmentFragment, unknown>;
export const PageInfoFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageInfoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PageInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]} as unknown as DocumentNode<PageInfoFragmentFragment, unknown>;
export const SaveCollectionColoursDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveCollectionColours"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionColourSaveInput"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionColourSaveInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveCollectionColour"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"collectionColourSaveInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionColourSaveInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<SaveCollectionColoursMutation, SaveCollectionColoursMutationVariables>;
export const GetAllBrandsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllBrands"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isDeleted"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brands"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"isDeleted"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isDeleted"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandNumber"}},{"kind":"Field","name":{"kind":"Name","value":"brandName"}},{"kind":"Field","name":{"kind":"Name","value":"brandShortName"}},{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}}]}}]}}]} as unknown as DocumentNode<GetAllBrandsQuery, GetAllBrandsQueryVariables>;
export const GetAllColourGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllColourGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"colourGroupNumbers"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"generalQuery"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"colourGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"colourGroupNumbers"},"value":{"kind":"Variable","name":{"kind":"Name","value":"colourGroupNumbers"}}},{"kind":"Argument","name":{"kind":"Name","value":"generalQuery"},"value":{"kind":"Variable","name":{"kind":"Name","value":"generalQuery"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"colourGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"colourGroupNumber"}},{"kind":"Field","name":{"kind":"Name","value":"masterColours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MasterColourFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MasterColourFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MasterColour"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"colourGroupNumbers"}},{"kind":"Field","name":{"kind":"Name","value":"masterColourNumber"}},{"kind":"Field","name":{"kind":"Name","value":"masterColourName"}},{"kind":"Field","name":{"kind":"Name","value":"masterColourHexCode"}},{"kind":"Field","name":{"kind":"Name","value":"masterColourCode"}},{"kind":"Field","name":{"kind":"Name","value":"colourTypeName"}},{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}}]}}]} as unknown as DocumentNode<GetAllColourGroupsQuery, GetAllColourGroupsQueryVariables>;
export const GetAllCountriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllCountries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"generalQuery"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"generalQuery"},"value":{"kind":"Variable","name":{"kind":"Name","value":"generalQuery"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageInfoFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryNumber"}},{"kind":"Field","name":{"kind":"Name","value":"countryName"}},{"kind":"Field","name":{"kind":"Name","value":"countryIsoCode3"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageInfoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PageInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]} as unknown as DocumentNode<GetAllCountriesQuery, GetAllCountriesQueryVariables>;
export const GetAllKeyOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllKeyOrders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandNumber"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isDeleted"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keyOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"isDeleted"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isDeleted"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keyOrderNumber"}},{"kind":"Field","name":{"kind":"Name","value":"keyOrderName"}},{"kind":"Field","name":{"kind":"Name","value":"expectedArrivalDate"}},{"kind":"Field","name":{"kind":"Name","value":"storeDeliveryDate"}}]}}]}}]} as unknown as DocumentNode<GetAllKeyOrdersQuery, GetAllKeyOrdersQueryVariables>;
export const GetAllLabelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllLabels"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"labelTypeNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"labelTypeNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"labelTypeNumber"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"labelNumber"}},{"kind":"Field","name":{"kind":"Name","value":"labelName"}}]}}]}}]} as unknown as DocumentNode<GetAllLabelsQuery, GetAllLabelsQueryVariables>;
export const GetAllMasterStyleCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllMasterStyleCategories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"masterStyleCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"masterStyleCategoryNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryNumber"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"masterStyleCategoryNumber"}},{"kind":"Field","name":{"kind":"Name","value":"masterStyleCategoryName"}},{"kind":"Field","name":{"kind":"Name","value":"masterStyleSubcategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"masterStyleSubcategoryNumber"}},{"kind":"Field","name":{"kind":"Name","value":"masterStyleSubcategoryName"}},{"kind":"Field","name":{"kind":"Name","value":"masterStyleSubcategoryAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"propertyTypeNumber"}},{"kind":"Field","name":{"kind":"Name","value":"masterStyleSubcategoryProperty"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAllMasterStyleCategoriesQuery, GetAllMasterStyleCategoriesQueryVariables>;
export const GetAllSuppliersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllSuppliers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchQuery"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"active"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isDeleted"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"factoryTypeToInclude"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FactoryTypeEnum"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"suppliers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"searchQuery"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchQuery"}}},{"kind":"Argument","name":{"kind":"Name","value":"active"},"value":{"kind":"Variable","name":{"kind":"Name","value":"active"}}},{"kind":"Argument","name":{"kind":"Name","value":"isDeleted"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isDeleted"}}},{"kind":"Argument","name":{"kind":"Name","value":"factoryTypeToInclude"},"value":{"kind":"Variable","name":{"kind":"Name","value":"factoryTypeToInclude"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supplierNumber"}},{"kind":"Field","name":{"kind":"Name","value":"supplierName"}},{"kind":"Field","name":{"kind":"Name","value":"paymentTermsCode"}},{"kind":"Field","name":{"kind":"Name","value":"factories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"factoryNumber"}},{"kind":"Field","name":{"kind":"Name","value":"factoryName"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}}]}}]} as unknown as DocumentNode<GetAllSuppliersQuery, GetAllSuppliersQueryVariables>;
export const GetCollectionColoursDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCollectionColours"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"generalQuery"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectionColours"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"generalQuery"},"value":{"kind":"Variable","name":{"kind":"Name","value":"generalQuery"}}},{"kind":"Argument","name":{"kind":"Name","value":"collectionNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectionColourNumber"}},{"kind":"Field","name":{"kind":"Name","value":"collectionNumber"}},{"kind":"Field","name":{"kind":"Name","value":"masterColour"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"masterColourNumber"}},{"kind":"Field","name":{"kind":"Name","value":"masterColourName"}},{"kind":"Field","name":{"kind":"Name","value":"masterColourHexCode"}},{"kind":"Field","name":{"kind":"Name","value":"masterColourCode"}},{"kind":"Field","name":{"kind":"Name","value":"colourTypeName"}},{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"changedBy"}},{"kind":"Field","name":{"kind":"Name","value":"changedDate"}},{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCollectionColoursQuery, GetCollectionColoursQueryVariables>;
export const GetAllDeliveryPeriodsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllDeliveryPeriods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deliveryPeriods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deliveryPeriodNumber"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryPeriodName"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}}]}}]} as unknown as DocumentNode<GetAllDeliveryPeriodsQuery, GetAllDeliveryPeriodsQueryVariables>;
export const GetFactoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFactories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supplierNumbers"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchQuery"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isActive"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"factoryTypeToInclude"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FactoryTypeEnum"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"factories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"supplierNumbers"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supplierNumbers"}}},{"kind":"Argument","name":{"kind":"Name","value":"searchQuery"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchQuery"}}},{"kind":"Argument","name":{"kind":"Name","value":"isActive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isActive"}}},{"kind":"Argument","name":{"kind":"Name","value":"factoryTypeToInclude"},"value":{"kind":"Variable","name":{"kind":"Name","value":"factoryTypeToInclude"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"factoryNumber"}},{"kind":"Field","name":{"kind":"Name","value":"factoryName"}},{"kind":"Field","name":{"kind":"Name","value":"suppliers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supplierName"}},{"kind":"Field","name":{"kind":"Name","value":"supplierNumber"}}]}}]}}]}}]} as unknown as DocumentNode<GetFactoriesQuery, GetFactoriesQueryVariables>;
export const GetMasterColoursDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMasterColours"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"generalQuery"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isDeleted"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"masterColours"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"generalQuery"},"value":{"kind":"Variable","name":{"kind":"Name","value":"generalQuery"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}},{"kind":"Argument","name":{"kind":"Name","value":"isDeleted"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isDeleted"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MasterColourFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MasterColourFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MasterColour"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"colourGroupNumbers"}},{"kind":"Field","name":{"kind":"Name","value":"masterColourNumber"}},{"kind":"Field","name":{"kind":"Name","value":"masterColourName"}},{"kind":"Field","name":{"kind":"Name","value":"masterColourHexCode"}},{"kind":"Field","name":{"kind":"Name","value":"masterColourCode"}},{"kind":"Field","name":{"kind":"Name","value":"colourTypeName"}},{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}}]}}]} as unknown as DocumentNode<GetMasterColoursQuery, GetMasterColoursQueryVariables>;
export const GetProductLineOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProductLineOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isDeleted"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productLines"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"isDeleted"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isDeleted"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productLineNumber"}},{"kind":"Field","name":{"kind":"Name","value":"productLineName"}}]}}]}}]} as unknown as DocumentNode<GetProductLineOptionsQuery, GetProductLineOptionsQueryVariables>;
export const GetPurchaseDivisionOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPurchaseDivisionOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isDeleted"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purchaseDivisions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"isDeleted"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isDeleted"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purchaseDivisionName"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseDivisionNumber"}}]}}]}}]} as unknown as DocumentNode<GetPurchaseDivisionOptionsQuery, GetPurchaseDivisionOptionsQueryVariables>;
export const GetStrategicTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetStrategicTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isDeleted"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"strategicTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"isDeleted"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isDeleted"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"strategicTypeNumber"}},{"kind":"Field","name":{"kind":"Name","value":"strategicType"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"brandNumber"}},{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}}]}}]}}]} as unknown as DocumentNode<GetStrategicTypesQuery, GetStrategicTypesQueryVariables>;